import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { TopBar } from "@/components/TopBar";
import { ArrowLeft, Sparkles, MessageCircle } from "lucide-react";

export default function Matches() {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/dating/matches");
        setMatches(data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0F17] pb-28">
      <TopBar />
      <div className="fixed top-14 left-0 right-0 z-30 bg-[#0B0F17]/85 backdrop-blur-md px-4 py-2 border-b border-white/5">
        <button onClick={() => navigate(-1)} data-testid="matches-back" className="inline-flex items-center gap-1.5 text-slate-400 hover:text-white text-sm">
          <ArrowLeft size={16} /> Back
        </button>
      </div>

      <main className="max-w-2xl mx-auto pt-24 px-4">
        <div className="mb-6">
          <div className="overline text-rose-400 mb-1">MUTUAL LIKES</div>
          <h1 className="font-display font-black text-3xl tracking-tight">Your matches.</h1>
        </div>

        {loading ? (
          <div className="grid grid-cols-2 gap-3">
            {[1, 2, 3, 4].map((i) => <div key={i} className="aspect-[3/4] bg-[#131A26] rounded-2xl animate-pulse" />)}
          </div>
        ) : matches.length === 0 ? (
          <div className="glass rounded-3xl p-8 text-center" data-testid="matches-empty">
            <Sparkles size={40} className="mx-auto text-amber-400 mb-4" />
            <h3 className="font-display font-bold text-xl mb-2">No matches yet</h3>
            <p className="text-slate-400 text-sm">Keep swiping!</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {matches.map((m) => (
              <Link
                key={m.id}
                to={`/chat/${m.other_user.id}`}
                data-testid={`match-${m.other_user.id}`}
                className="group relative aspect-[3/4] rounded-2xl overflow-hidden bg-[#131A26] border border-white/10 hover:border-rose-500/40 transition-colors"
              >
                <img
                  src={m.other_user.dating_photos?.[0] || m.other_user.photo_url || `https://api.dicebear.com/7.x/personas/svg?seed=${m.other_user.id}`}
                  alt={m.other_user.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                <div className="absolute bottom-2 left-2 right-2">
                  <div className="font-display font-bold text-sm truncate">{m.other_user.name}</div>
                  <div className="inline-flex items-center gap-1 text-[10px] text-rose-300 mt-0.5">
                    <MessageCircle size={10} /> Say hi
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
